import { DateTime, Duration } from 'luxon';
import { TIME_RANGES, TIME_RANGE_DEFAULT, TypeDuration } from '../../constants/TimeRange';
import isDurationValid from './isDurationValid';
import isTimeRangeSameDay from './isTimeRangeSameDay';
import isTimeRangeValid from './isTimeRangeValid';

const getTimeRange = (
  duration: TypeDuration,
  dateFrom?: number,
  dateTo?: number,
): {
  dateFrom: number;
  dateTo: number;
  text: string;
} => {
  if (duration === 'FIXED' && isTimeRangeSameDay(dateFrom, dateTo)) {
    return {
      dateFrom: DateTime.fromMillis(dateFrom as number)
        .startOf('day')
        .toUTC()
        .toMillis(),
      dateTo: DateTime.fromMillis(dateTo as number)
        .endOf('day')
        .minus({ second: 1 })
        .toUTC()
        .toMillis(),
      text: DateTime.fromMillis(dateFrom as number).toFormat('d MMM'),
    };
  }

  if (duration === 'FIXED' && isTimeRangeValid(dateFrom, dateTo)) {
    return {
      dateFrom: DateTime.fromMillis(dateFrom as number)
        .startOf('day')
        .toUTC()
        .toMillis(),
      dateTo: DateTime.fromMillis(dateTo as number)
        .endOf('day')
        .minus({ second: 1 })
        .toUTC()
        .toMillis(),
      text: `${DateTime.fromMillis(dateFrom as number).toFormat('d MMM')} - ${DateTime.fromMillis(
        dateTo as number,
      ).toFormat('d MMM')}`,
    };
  }

  return {
    dateFrom: DateTime.local()
      .endOf('hour')
      .minus(
        Duration.fromISO(
          isDurationValid(duration) ? (duration as string) : TIME_RANGE_DEFAULT,
        ).toObject(),
      )
      .plus({ second: 1 })
      .toUTC()
      .toMillis(),
    dateTo: DateTime.local().endOf('hour').minus({ second: 1 }).toUTC().toMillis(),
    text: (TIME_RANGES.find((range) => range.value === duration) || { text: TIME_RANGES[0].text })
      .text,
  };
};

export default getTimeRange;
